import { pass } from './../app/session/store/session.selectors';
import { otherSystemData } from 'src/app/session/store/session.selectors';
import { Injectable, Renderer2, ElementRef, RendererFactory2 } from "@angular/core";
import { environment } from 'src/environments/environment';
import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { tap, first } from 'rxjs/operators';
import { ToastService } from 'src/app/services/toast.service';

@Injectable()
export class JiraAccess {

	private readonly jiraRegExpList: RegExp[] = []; // = new RegExp( environment.jiraBaseUrl1 );
	private renderer: Renderer2;


	constructor( private store: Store<AppState>, rendererFactory: RendererFactory2, private toastService: ToastService ) {
		this.renderer = rendererFactory.createRenderer( null, null );

		// Inicializo jiraRegExpList
		environment.jiraBaseUrl.forEach( (exp: string) => {
			this.jiraRegExpList.push( new RegExp( exp ) );
		});
	}

	public isJiraUrl( url: string ) {
		return this.jiraRegExpList.some( regExp => regExp.exec( url ) != null );
	}

	/**
	 * Abre una url de Jira con el usuario de Intranet ya logueado en Jira.
	 * 
	 * @param url, url de jira
	 * @param target: especifica el nombre de un iframe o ventana donde se abrirá la url
	 * @param fromElement: elemento del DOM que solicita la apertura del link de Jira
	 */
	public openJira( url: string, target: string, fromElement: ElementRef ) {
		combineLatest( this.store.select( otherSystemData ), this.store.select( pass ) )
			.pipe(
				first(),
				tap( ([ otherSystemData, pass ]) => {
					// Si hay usuario y clave => realizo el login vía el form y luego se redirecciona
					// el resultado del submit al iframe
					// sino => mensaje de error
					if( pass && pass != '' ) {
						let form: any = this.createForm( url, otherSystemData.nombreUsuario, pass, target );
						fromElement.nativeElement.appendChild( form );
						form.submit();
						form.remove();
					} else {
						this.toastService.danger( "No se ha podido abrir la página de Jira solicitada" );
					}
				})
			).subscribe();
	}

/*
 * private methods
 */

	/**
	 * Retorna el siguiente formulario como objeto listo para ser agregado al DOM.
	 * 
	 * <form #form action="..." method="post" target="login" style="display: none">
	 *     <input name="os_username" value="...">
	 *     <input name="os_password" value="...">
	 *     <input name="os_cookie" value="true">
	 *     <input name="os_destination" value="...">
	 * </form>
	 */
	private createForm( action: string, user: string, pass: string, target: string ): any {
		// Create input elements
		let username: any = this.renderer.createElement( 'input' );
		this.renderer.setProperty( username, "name", "os_username" );  
		this.renderer.setProperty( username, "value", user );  
		let password: any = this.renderer.createElement( 'input' );
		this.renderer.setProperty( password, "name", "os_password" );
		this.renderer.setProperty( password, "value", pass );		
		let cookie: any = this.renderer.createElement( 'input' );
		this.renderer.setProperty( cookie, "name", "os_cookie" );
		this.renderer.setProperty( cookie, "value", "true" );		
		let destination: any = this.renderer.createElement( 'input' );
		this.renderer.setProperty( destination, "name", "os_destination" );
		this.renderer.setProperty( destination, "value", action );		
 
		// Create form
		let form: any = this.renderer.createElement( 'form' );
		//this.renderer.setStyle( form, "display", "none" );
		this.renderer.setProperty( form, "method", "post" );
		this.renderer.setProperty( form, "action", action );
		this.renderer.setProperty( form, "target", target );
		this.renderer.appendChild( form, username );
		this.renderer.appendChild( form, password );		
		this.renderer.appendChild( form, cookie );
		this.renderer.appendChild( form, destination );
		
		return form;
	}

}